const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const isEuVersion = BACKEND_URL.split('.')[BACKEND_URL.split('.').length - 1] === 'eu'
